module.exports = __webpack_public_path__ + "img/潍坊联运有限责任公司.ee8da1cf.jpg";